<script>
import CardImg from './CardImg';

export default {

    name: 'CardImgBottom',

    extends: CardImg

};
</script>
